import type { DashboardLibraryState } from '@highimpact/dashboard-types';
import { createAction } from '@reduxjs/toolkit';

/** Replaces all library slices from host payload. */
export const hydrateDashboardLibraryState = createAction<DashboardLibraryState>(
  'dashboardLibrary/hydrate'
);
